<template>
  <div class="login-wrap">
    <div class="logo">
      <img src="../assets/img/易至出行.png" style="vertical-align: middle;" />
      <b style="margin-left: 4px;">易至出行网约车管理平台</b>
    </div>

    <div class="three">
      <div class="ms-login">
        <div class="ms-title">欢迎登录</div>
        <br />
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="0px"
          class="ms-content"
        >
          <el-form-item prop="username">
            <el-input v-model="ruleForm.username" placeholder="请输入用户名或手机号">
              <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
            </el-input>
          </el-form-item>
          <br />
          <el-form-item prop="password">
            <el-input type="password" placeholder="请输入密码" v-model="ruleForm.password">
              <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
            </el-input>
          </el-form-item>
          <br />
          <el-form-item prop="validateCode">
            <el-input
              placeholder="请输入验证码"
              v-model="ruleForm.validateCode"
              @keyup.enter.native="submitForm('ruleForm')"
              style="width: 180px;"
            >
              <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
            </el-input>
            <el-button :style="codeTextStyle" @click="getCaptcha" :disabled="onSubmit">{{codeText}}</el-button>
          </el-form-item>
          <br />
          <div class="login-btn">
            <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
          </div>
          <!--          <div class="serverFile">-->
          <!--           <a href="#" target="_blank" >《平台服务规则》</a>-->
          <!--          </div>-->
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import md5 from "js-md5";
export default {
  data: function() {
    return {
      codeImage: "",
      loading: false,
      ruleForm: {
        username: "",
        password: "",
        validateCode: ""
      },
      onSubmit: false,
      codeText: "获取验证码",
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名/手机号",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ],
        validateCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {},
  computed: {
    codeTextStyle() {
      let value;
      if (!this.onSubmit) {
        value = 90;
      } else {
        value = 102;
      }
      return "width:" + value + "px";
    }
  },
  methods: {
    getCaptcha() {
      let username = this.ruleForm.username;
      let password = this.ruleForm.password;
      if (
        username !== "" &&
        username != null &&
        password !== "" &&
        password != null
      ) {
        this.$post("getLoginCode", {
          username: this.ruleForm.username,
          password: md5(this.ruleForm.password)
        })
          .then(res => {
            if (res.data.code === 0) {
              this.$message.success("验证码已发送,请于5分钟内输入正确验证码");
            } else {
              this.$message.warning(res.data.msg);
            }

            let wait_timer = 60;
            let that = this;
            var timer_interval = setInterval(() => {
              if (wait_timer > 0) {
                wait_timer--;
                that.codeText = wait_timer + "s后重新获取";
                that.onSubmit = true;
              } else {
                clearInterval(timer_interval);
                that.codeText = "获取验证码";
                that.onSubmit = false;
              }
            }, 1000);
          })
          .catch(error => {
            this.$message.error(error);
          });
      } else {
        this.$message.warning("用户名或密码不能为空");
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$post("login", {
            username: this.ruleForm.username,
            password: md5(this.ruleForm.password),
            validateCode: this.ruleForm.validateCode
          })
            .then(res => {
              if (res.data.message === "认证成功") {
                let data2 = res.data.data;
                this.saveLoginData(data2);
                setTimeout(() => {
                  this.loading = false;
                }, 500);
                this.$router.push("/");
              } else {
                alert(res.data.message);
              }
            })
            .catch(error => {
              console.log(error);
              alert(error.msg);
              setTimeout(() => {
                this.loading = false;
              }, 500);
            });
        } else {
          this.$message.warning("请输入必填信息");
        }
      });
    },

    ...mapMutations({
      setToken: "account/setToken",
      setExpireTime: "account/setExpireTime",
      setPermissions: "account/setPermissions",
      setRoles: "account/setRoles",
      setUser: "account/setUser",
      setTheme: "setting/setTheme",
      setLayout: "setting/setLayout",
      setMultipage: "setting/setMultipage",
      fixSiderbar: "setting/fixSiderbar",
      fixHeader: "setting/fixHeader",
      setColor: "setting/setColor"
    }),
    saveLoginData(data) {
      this.setToken(data.token);
      this.setExpireTime(data.exipreTime);
      this.setUser(data.user);
      this.setPermissions(data.permissions);
      this.setRoles(data.roles);
      this.setTheme(data.config.theme);
      this.setLayout(data.config.layout);
      this.setMultipage(data.config.multiPage === "1");
      this.fixSiderbar(data.config.fixSiderbar === "1");
      this.fixHeader(data.config.fixHeader === "1");
      this.setColor(data.config.color);
    }
  }
};
</script>

<style scoped>
.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../assets/img/bg@3x.png);
  background-size: 100%;
}

.logo {
  position: relative;
  top: 3%;
  left: 5%;
}

.three {
  position: relative;
  top: 45%;
  left: 20%;
  background-image: url(../assets/img/middle@2x.png);
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
}

.ms-login {
  position: relative;
  left: 43%;
  width: 350px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.3);
  overflow: hidden;
}

.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  border-bottom: 1px solid #ddd;
}

.ms-content {
  padding: 30px 30px;
}

.login-btn {
  text-align: center;
}

.login-btn button {
  width: 100%;
  height: 36px;
  margin-bottom: 10px;
}

.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue